// removed by extract-text-webpack-plugin
module.exports = {"content":"_1dXBS","info-container":"_3PyII","avatar-wrapper":"_2dD6N","avatar":"_54bOA","owner-name":"_9L9ul","date":"_114jC","message":"_1Z7yQ","media-container":"NLZsw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItem.scss
// module id = ./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItem.scss
// module chunks = 5